"use strict";
/*
 * Created on 03 20 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var PriceStickersWeekReportDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceStickersWeekReportDTOConverter, _DataObjectConverter_);

  function PriceStickersWeekReportDTOConverter() {
    _classCallCheck(this, PriceStickersWeekReportDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceStickersWeekReportDTOConverter).apply(this, arguments));
  }

  return PriceStickersWeekReportDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceStickersWeekReportDTOConverter = PriceStickersWeekReportDTOConverter;